//获取静态资源地址
import { APP_SKIN } from "@/constants/constants";
import { ResConfig } from "@/constants/resConfig";
import { getCurrentRequestLangKey, getLangKey } from "@/i18n";
import { configStore } from "@/stores/configStore";
import type { FrontCfgGameConfigData } from "@/types/config";
import { FrontCfgV2Info } from "@/types/swagger/front";

//根据游戏id返回图片地址
export const getGameimgurlByGameId = (
  gameid: number | undefined,
  folder?: string,
  org_icon_folder?: string,
  ext_icon_folder?: string,
  isTop10?: boolean,
): string => {
  if (!gameid) return "";
  let gameImg_folder = ResConfig["game-icon-folder"];
  const gameIconDomin = ResConfig["game-icon"];
  const domain = gameIconDomin[gameid % gameIconDomin.length];
  const isOringinal =
    Number(gameid) < 100000 || `${gameid}`.substring(1, 4) == "000"; //小于100000自研cocos游戏 或者 游戏id第234位为000 为其他部门自研

  const frontCfg = configStore.frontCfgMap[
    "GameConfig"
  ] as unknown as FrontCfgV2Info; // frontcfg获取全局配置
  const frontCfg_gameconfig_data =
    frontCfg as unknown as FrontCfgGameConfigData;
  if (isOringinal) {
    gameImg_folder =
      folder || //组件自定义目录
      org_icon_folder || //组件自研游戏
      frontCfg_gameconfig_data?.gameFolder || //全局自定义目录
      frontCfg_gameconfig_data?.orgGameFolder || //全局自研游戏目录
      ResConfig["game-icon-folder"]; // 写死默认目录
  } else {
    gameImg_folder =
      folder || //组件自定义目录
      ext_icon_folder || //组件外接游戏
      frontCfg_gameconfig_data?.gameFolder || //全局自定义目录
      frontCfg_gameconfig_data?.extGameFolder || //全局外接游戏目录
      ResConfig["game-icon-folder"];
  }
  const o_id = Number(gameid) < 100000 ? "0" : `${gameid}`.substring(1, 4); //外接游戏 取游戏id 第234位 为目录，自研游戏目录为 0
  const ext = isTop10
    ? ResConfig["game-icon-type-top10"]
    : ResConfig["game-icon-type"];
  const src = `${domain}${gameImg_folder}/${o_id}/${gameid}.${ext}`;

  return src;
};

//根据模块获取图片地址
// prettier-ignore
export const getImgUrlWithSkin = ( imgname: string, path: string, skin: string = APP_SKIN): string => {
  return `${ResConfig["root-address"]}b_fun/${skin}/${path}/${imgname}`;
};
// countryIcon
export const getCountryIconByCurreny = (curreny: string): string => {
  return `${ResConfig["root-address"]}b_fun/common/country_icon/${curreny}.svg`;
};

export const getGClassIconByGClass = (gclass: string) => {
  return `${ResConfig["root-address"]}b_fun/common/gclassImage/${gclass}.png`;
};

/** 获取头像图片地址 */
// prettier-ignore
export const getHeadImgurl = (headImg: number | string): string => {
  const num = Number(headImg);
  const imgName = isNaN(num) ? 'default.png' : num % 15 +".jpg";
  return `${ResConfig["root-address"]}b_fun/common/avatar/h_${imgName}`;
};

export const getImgurl = (imgname: string, path: string): string => {
  return (
    ResConfig["root-address"] +
    "cdn-cgi/image/format=auto/b_fun/" +
    path +
    "/" +
    imgname
  );
};
export const getTop10NumImgurl = (imgname: string, path: string): string => {
  return (
    ResConfig["root-address"] +
    "cdn-cgi/image/format=auto/" +
    path +
    "/" +
    imgname
  );
};

/**
 * 获取图片地址（对皮肤多包网）
 *
 * ! 注意：多皮肤目录在 @svn: /b_fun/skins/ 目录下，每个皮肤下分 betaya bfun eluck，资源别放漏了。
 *
 * @param imgName 图片名称，如 logo.png
 * @param path 资源路径，如 common
 * @param useLanguage 是否使用国际化标识
 * @returns
 */
export const getImgUrlPro = (
  imgName: string,
  path: string,
  useLanguage?: boolean,
): string => {
  const root = ResConfig["root-address"];
  const appName = __APP_NAME__;
  const cfPath = "cdn-cgi/image/format=auto/b_fun/skins/";
  const [_imgName, _imgExt] = imgName.split(".");
  if (useLanguage) {
    imgName = `${_imgName}_${getLangKey()}.${_imgExt}`;
  }
  return `${root}${cfPath}${APP_SKIN}/${appName}/${path}/${imgName}?v=202511141003`;
};
export const getImgurlWithAppName = (
  imgname: string,
  path: string,
  useLanguage: boolean = false,
): string => {
  const root = ResConfig["root-address"];
  const appName = __APP_NAME__;
  const cfPath = "cdn-cgi/image/format=auto/b_fun/";
  const imgName = imgname.split(".")[0];
  const imgExt = imgname.split(".")[1];
  if (useLanguage) {
    imgname = `${imgName}_${getLangKey()}.${imgExt}` + "?v=10311847";
  }
  path = `${appName}/` + path;
  const url = root + cfPath + path + "/" + imgname;

  return url;
};

export const getFileUrl = (fileName: string, path: string): string => {
  let url = ResConfig["root-address"] + "b_fun" + "/" + path + "/" + fileName;

  if (fileName.includes(".lottie")) {
    url += "?timestamp=" + Date.now();
  }
  return url;
};

export const getSkinFileUrl = (fileName: string, path: string): string => {
  return ResConfig["root-address"] + "b_fun" + path + "/" + fileName;
};

export const getNoLoginBgImage = () => {
  return `${ResConfig["root-address"]}b_fun/login/bg_nologin.png`;
};
export const getCountryImage = (acode: string) => {
  return (
    ResConfig["root-address"] +
    `/dev_skin/C02/home/country/area/Area_Code_${acode}.svg?t202411122151`
  );
};
export const getProviderLogo_winner = (logo: string) => {
  if (logo.startsWith("http")) {
    return logo;
  }
  return `${ResConfig["root-address"]}${ResConfig["plat-icon-folder-winner"]}/${logo}.png`;
};
export const getProviderLogo = (logo: string) => {
  if (!logo) return "";
  if (logo.startsWith("http")) {
    return logo;
  }
  return `${ResConfig["root-address"]}${ResConfig["plat-icon-folder"]}/${logo}.png`;
};
export const getUserVip = (level: string) => {
  return `${ResConfig["root-address"]}b_fun/common/vip/${level}.png`;
};
export const getVipTag = (level: string) => {
  return `${ResConfig["root-address"]}b_fun/common/vip_tag/${level}.png`;
};
export const getGameDefaultImg = () => {
  return `${ResConfig["root-address"]}b_fun/${APP_SKIN}/common/GameDefault.png`;
};
export const getCommonImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/common/${path}`;
};

export const getTournamentImg = (path: string) => {
  return `${ResConfig["root-address"]}s_static/tournament/${path}`;
};

/** 获取组件图片 */
export const getComponentImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/component/${path}`;
};
/** 获取个人中心图片 */
export const getProfileImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/profile/${path}`;
};
/** 获取弹窗图片 */
export const getPopupImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/popup/${path}?20250614`;
};

/** 获取 VIP 升级弹窗图片 */
export const getVipPopupImg = (type: "h5" | "pc") => {
  return `${ResConfig["root-address"]}b_fun/popup/vip/${type}-popup.png`;
};

/** 获取 VIP h5-背景图片 */
export const getVipBannerImg = (type: "h5" | "pc") => {
  return `${ResConfig["root-address"]}b_fun/vip/${type}-vip-bg.jpg`;
};

export const getVipLevelBannerImg = (level: number, type: "h5" | "pc") => {
  return `${ResConfig["root-address"]}b_fun/vip/vip${level}-bg-${type}.png?20250701`;
};

/** 获取 Bonus info 背景图片 */
export const getBonusInfoBgImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/bonusCenter/${path}.png?123`;
};

/** 获取 Bonus header 图片 */
export const getBonusHeaderImg = () => {
  return `${ResConfig["root-address"]}b_fun/bonusCenter/bonus-animation.webp`;
};

/** 获取 Bonus no-login 图片 */
export const getBonusNoLoginImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/bonusCenter/no-login2/${path}?1129`;
};

/** 获取 新人七日签到 图片 */
export const getNewCheckInImg = (img: string) => {
  return `${ResConfig["root-address"]}b_fun/activity/newCheckIn/${img}`;
};

/** 获取 vip 图片 */
export const getVipActivityImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/vip2/${path}.png?20250701`;
};

/** 获取 钱包 图片 */
export const getWalletImg = (path: string, img: string) => {
  return `${ResConfig["root-address"]}b_fun/wallet/${path}/${img}`;
};

/** 获取 体育 图片 */
export const getSportImg = (path: string) => {
  return `${ResConfig["root-address"]}b_fun/sports/${path}`;
};

/** 获取 下载 图片 */
export const getInstallImg = (img: string) => {
  return `${ResConfig["root-address"]}b_fun/install/common/${img}?20251114`;
};
